import React from 'react'
import * as timeUtils from '../util/time_utils'
import { isEndBeforeStart } from  '../common/components/time_input'

class TimeInput extends React.Component {
    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
        this.handleBlur = this.handleBlur.bind(this)
        this.state = { value: props.value || '' }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.value !== nextProps.value) {
            this.setState({ value: nextProps.value })
        }


        const { value: endAtTime, startAt, endAt } = nextProps
        if (isEndBeforeStart(endAtTime, startAt, endAt)) {
            nextProps.onChange(timeUtils.stringToTimeString(new Date(nextProps.startAt).toLocaleTimeString()))
        }

    }

    handleChange(e) {
        this.setState({value: e.target.value})
    }

    handleBlur(e) {
        let time = e.target.value
        if (!time && this.props.hasDefaultTime) {
            time = new Date().toLocaleTimeString()
        }

        this.props.onChange(timeUtils.stringToTimeString(time))
    }

    select() {
        setTimeout(() => {
            this.input.focus()
            this.input.setSelectionRange(0, 9999)
        }, 1)
    }

    render() {
        return (
            <input
                type="text"
                ref={(input) => {this.input = input}}
                style={this.props.style || {}}
                className={this.props.className}
                placeholder={this.props.placeholder || ''}
                value={this.state.value}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                onFocus={this.props.onFocus}
            />
        )
    }
}

export default TimeInput



// WEBPACK FOOTER //
// ./src/components/time_input.jsx